<template>
  <footer class="absolute bottom-0 h-16 flex w-full justify-between items-center pl-10 pr-4">
    <div class="flex items-center">
      <small class="text-xs text-gray-200">
        Copyright
        <font-awesome-icon  class="text-gray-300 text-xs" icon="copyright" />
        2022
      </small>
    </div>
     <a href="https://github.com/javarcast" class="items-center flex">
      <img src="@/assets/images/logo.png" class="h-6" alt="Logo Varcast">
      <p class="text-gray-200 text-md">VarCast</p>
    </a>

    <div class="text-center hidden md:flex flex-wrap justify-center items-center">
      <p class="text-gray-200 text-xs w-full">{{$t('powered-by')}}</p>
      <font-awesome-icon class="text-vue mx-2 text-lg"
        :icon="['fab','vuejs']" />
      <font-awesome-icon class="text-fontawesome mx-2 text-lg"
        :icon="['fab','font-awesome']" />
      <font-awesome-icon class="text-github mx-2 text-lg"
        :icon="['fab','github']" />
      <img src="@/assets/images/skills/tailwindcss.png" class="h-6" alt="tailwindcss logo">
    </div>
  </footer>
</template>
<script>
export default {
  name: 'FooterBar',
};
</script>
<style scoped>
  footer {
    font-family: 'Varela Round', sans-serif;
  }
</style>
